// Item 13 — drillthrough back-navigation state.
//
// The page a drillthrough starts from registers a snapshot provider (dashboard filters, slicer
// selections, filter-widget values, scroll position, selected widget). `navigateDrill` stores that
// snapshot in sessionStorage and puts its key in the drill payload, so "Back" (and every step of a
// chained A → B → C trail) restores the originating dashboard exactly as the user left it instead
// of reloading a blank one.

const KEY = (k) => `eip_navstate_${k}`;

let provider = null;

export function registerNavState(fn) {
  provider = fn;
  return () => { if (provider === fn) provider = null; };
}

export function snapshotNavState() {
  try { return provider ? provider() : null; } catch { return null; }
}

export function saveNavState(state) {
  const key = `n${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
  try { sessionStorage.setItem(KEY(key), JSON.stringify(state || {})); } catch { return null; }
  return key;
}

export function readNavState(key) {
  if (!key) return null;
  try {
    const raw = sessionStorage.getItem(KEY(key));
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

// Restores scroll after the dashboard has painted.
export function applyScroll(y) {
  if (!Number.isFinite(Number(y))) return;
  const go = () => window.scrollTo({ top: Number(y), behavior: "auto" });
  requestAnimationFrame(() => setTimeout(go, 120));
}

// Modal drillthrough: the target renders inside an iframe with `dtmodal=1`; chrome marked with
// data-chrome is hidden so only the dashboard content shows.
export function setModalChrome(on) {
  if (typeof document === "undefined") return;
  if (on) document.documentElement.setAttribute("data-dtmodal", "1");
  else document.documentElement.removeAttribute("data-dtmodal");
}
